export default "__VITE_ASSET__7be600ae__"